import { render, staticRenderFns } from "./ListAzaFile.vue?vue&type=template&id=55d05bcd&"
import script from "./ListAzaFile.vue?vue&type=script&lang=js&"
export * from "./ListAzaFile.vue?vue&type=script&lang=js&"
import style0 from "./ListAzaFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports